const E = "errors", o = [".jpg", ".jpeg", ".png"], I = "*";
export {
  E as ERROR_EVENT,
  o as IMAGE_FILE_PREVIEW_EXTENSIONS,
  I as WILDCARD
};
